module.exports = __webpack_public_path__ + "images/single-polygon-2.png";